window.theme.component('offer-categories', el => {
	const list = el.querySelector('.js-offer-categories-list');
	const toggle = el.querySelector('.js-offer-categories-toggle');

	if (!list || !toggle) return;

	toggle.addEventListener('click', () => {
		const expanded = list.classList.toggle('is-expanded');
		toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		const label = toggle.querySelector('span');
		if (label) label.textContent = expanded ? 'Mostrar menos' : 'Mostrar mais';
	});
});
